import { CommonEntity, ChildEntity } from '$/entities/BaseEntity';
import { TenantCheck }               from '$/entities/tenantScreening/TenantCheck';

/**
 * An identity verification check that uses Persona's ID verification service.
 */
@CommonEntity() @ChildEntity()
export class PersonaIDVCheck extends TenantCheck {

	get label() {
		return 'Persona ID Verification';
	}

}
